__turbopack_context__.v({
  "selectedCard": "TeamMembersAdd-module-scss-module__xSG7ta__selectedCard",
  "selectedList": "TeamMembersAdd-module-scss-module__xSG7ta__selectedList",
  "teamLeadLabel": "TeamMembersAdd-module-scss-module__xSG7ta__teamLeadLabel",
  "teamLeadToggle": "TeamMembersAdd-module-scss-module__xSG7ta__teamLeadToggle",
});
